const KEY = "kiddee_chat_used";
const WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

// Remembers that the shopper chatted with Kiddee so a purchase in the next 7 days counts as chat-assisted.
export const markChatUsed = (session) => localStorage.setItem(KEY, JSON.stringify({ session, at: Date.now() }));

export const chatSessionForCheckout = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY));
    return saved && Date.now() - saved.at < WINDOW_MS ? saved.session : null;
  } catch {
    return null;
  }
};
